import { useEffect, useRef } from "react";

const WIDGET_ID = "JFWebsiteWidget-01a0392e51a07000864595f01f76c38d6439";
const WIDGET_SCRIPT_URL =
  "https://www.jotform.com/website-widgets/embed/01a0392e51a07000864595f01f76c38d6439";

const JotformWebsiteWidget = () => {
  const widgetRef = useRef(null);

  useEffect(() => {
    const widget = widgetRef.current;

    if (!widget) {
      return undefined;
    }

    const script = document.createElement("script");
    script.src = WIDGET_SCRIPT_URL;
    script.async = true;
    script.setAttribute("data-jotform-widget-loader", "true");
    widget.insertAdjacentElement("afterend", script);

    return () => {
      script.remove();
      widget.replaceChildren();
    };
  }, []);

  return <div id={WIDGET_ID} ref={widgetRef} />;
};

export default JotformWebsiteWidget;
